import { useCallback, useState } from "react";

/**
 * Hook that wraps over `pushState` and forces a re-render after change.
 *
 * This will NOT be necesary if/when we integrate an actual router.
 */
export const useUrlNav = () => {
  const [, updateState] = useState({});
  const forceRender = useCallback(() => updateState({}), []);

  return {
    push(url: string) {
      window.history.pushState({}, "", url);
      forceRender();
    },
  };
};
